import * as types from '../mutation-types'
import { requestOnce, decryptQrData, normalizeQrEntity } from '@/helpers/functions'

/*
	المعرّفات القادمة من معاملات المسار (route query) نصوص بينما معرّفات الـ API أرقام،
	فمقارنة === تفشل بصمت ويظهر الاسم فارغاً - نقارن بعد التوحيد إلى نص
*/
const sameId = (a, b) => a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b)

export default {
	namespaced: true,

	state: {
		entities: [],
		allEntities: [],
		customersTypes: [],
		customersCountsByType: [],
		accounts: []
	},

	actions: {
		fetchAll({ commit }, { entityType, name: query, regionId }) {
			const params = { entityType, query, regionId };
			// never send empty query params (keep valid 0 / false values)
			Object.keys(params).forEach(key => {
				if (params[key] === null || params[key] === undefined || params[key] === '') delete params[key];
			});
			return window.axios.get('/entitiesWithTypeId/all', { params })
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		fetchAllData({ commit }, { typeId, name, regionIds, perPage }) {
			return window.axios.get('/entitiesWithTypeId', {
				params: {
					typeId,
					name,
					regionIds,
					includeContactInfo: true,
					includeAddresses: true,
					nonDeleted: true,
					page: 1,
					perPage
				},
				// regionIds is collectionFormat:multi - axios' default `ids[]=` form
				// is not bound by the API and the filter is silently ignored otherwise
				paramsSerializer: { indexes: null }
			})
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		/*
			يجلب كل الزبائن مجمّعين حسب المنطقة (بلا فلاتر)، ويُسطّحهم بنفس شكل عناصر state.entities
			لكن ضمن state.allEntities المنفصلة - كي لا يتصادم هذا الجلب غير المُصفّح (~11 ألف سجل)
			مع القائمة المُرقّمة (paginated) التي تعرضها صفحة الزبائن عبر state.entities، وإلا قد يُستبدل
			عرض 10 عناصر بكامل قاعدة الزبائن إذا وصل هذا الطلب متأخراً (سباق مع fetchAllData/fetchAll)
			الهدف: تغطية أوفلاين أشمل عند الإقلاع، بغضّ النظر عن آخر فلتر استُخدم في صفحة الزبائن -
			ولذلك تبحث getEntityById/getEntityByAccountId في state.allEntities أيضاً كاحتياط
			عند تعطّل الشبكة يُعيد الـ service worker بيانات مسطّحة أصلاً (من متجر entities المشترك)
			بدل الشكل المتداخل - لذا "region.customers" غير موجود حينها، ويُعامَل العنصر كزبون مباشرة
		*/
		fetchAllGroupedByRegion({ commit }) {
			return window.axios.get('/Regions/Customers').then(({ data }) => {
				const entities = (data || []).flatMap(region =>
					region.customers
						? region.customers.map(customer => ({
							regionId: region.regionId,
							regionName: region.region,
							...customer
						}))
						: [region]
				);
				commit(types.STORE_ALL_ENTITIES, entities);
				return entities;
			})
		},

		fetchMatchedEntities({ commit }, { name, regionId }) {
			return window.axios.get('/entityExistCheck', { params: { name, regionId } })
				.then(({ data }) => data)
		},

		modify({ commit }, { 
			requestType,
			entityId,
			typeId,
			name,
			reason,
			specialtyId,
			entityAddresses,
			contactInfos,
			entityType,
			loyality,
			relegion,
			personality,
			birthdate,
			weekend,
			personalNote,
			customerInfo,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			pmWorkHour,
			amWorkHour,
			ownerInfo,
			residentDoctorNames
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion
            */
			return window.axios.post('/requests/entitymodifications',
				{ 
					entityType,
					requestType,
					entityId,
					typeId,
					name,
					reason,
					specialtyId,
					entityAddresses,
					contactInfos,
					loyality,
					relegion,
					personality,
					birthdate,
					weekend,
					personalNote,
					customerInfo,
					hobbies,
					nearbyPointOfSales,
					visitNotes,
					worksInCenters,
					pmWorkHour,
					amWorkHour,
					ownerInfo,
					residentDoctorNames
				})
		},
	
		directModify({ commit }, { 
			requestType, 
			entityId, 
			typeId, 
			name, 
			reason, 
			specialtyId, 
			entityAddresses, 
			contactInfos, 
			entityType,
			// new
			loyality,
			relegion,
			personality,
			birthdate,
			amWorkHour,
			pmWorkHour,
			// weekend,
			residentDoctorNames,
			personalNote,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			customerInfo,
			ownerInfo,
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion

                entityType:
                0 = Center
                1 = Doctor
                2 = Pharmacy
                3 = External
            */
			return window.axios.post('/requests/EntityModifications/AddEntityWithRequest', { 
				requestType, 
				entityId, 
				typeId, 
				name, 
				reason, 
				specialtyId, 
				entityAddresses, 
				contactInfos, 
				entityType,
				// new
				loyality,
				relegion,
				personality,
				birthdate,
				amWorkHour,
				pmWorkHour,
				// weekend,
				residentDoctorNames,
				personalNote,
				hobbies,
				nearbyPointOfSales,
				visitNotes,
				worksInCenters,
				customerInfo,
				ownerInfo
			})
		},

		/*
			صور محل العميل
			لا نضبط Content-Type: تمرير FormData يجعل المتصفح يولّد الـ boundary بنفسه
			preventRouteAbort: رفع الصورة قد يطول، ولا نريد إلغاءه عند تغيير الصفحة
		*/
		uploadImage ({ commit }, { entityId, image, isDefault = true }) {
			const formData = new FormData();
			formData.append('EntityId', entityId);
			formData.append('Image', image);
			formData.append('IsDefault', isDefault);
			return window.axios.post('/Entities/Images', formData, { preventRouteAbort: true })
		},

		deleteImage ({ commit }, imageId) {
			return window.axios.delete(`/Entities/Images/${imageId}`, { preventRouteAbort: true })
		},

		fetchImages ({ commit }, entityId) {
			return window.axios.get(`/Entities/${entityId}/Images`).then(({ data }) => data)
		},

		/*
			صور طلب تعديل/إضافة جهة: الزبون الجديد لا يملك معرّفاً بعد،
			والسيرفر يرجّع معرّف الطلب، فتُربط الصورة بالطلب نفسه لا بالزبون
		*/
		uploadRequestImage ({ commit }, { requestId, image, isDefault = true }) {
			const formData = new FormData();
			formData.append('RequestId', requestId);
			formData.append('Image', image);
			formData.append('IsDefault', isDefault);
			return window.axios.post('/Requests/EntityModifications/Images', formData, { preventRouteAbort: true })
		},

		fetchRequestImages ({ commit }, requestId) {
			return window.axios.get(`/Requests/EntityModifications/${requestId}/Images`).then(({ data }) => data)
		},

		fetchEntityType ({ commit }) {
			return requestOnce('/entities/types', () => window.axios.get('/entities/types')).then(({ data }) => {
				commit(types.STORE_CUSTOMERS_TYPES, data)
				return data
			})
		},

		/*
			عدد زبائن المندوب الحالي مقسّماً على أنواع الزبائن
			الشكل المتوقع للرد: [{ typeId: 1, count: 128 }, ...]
			preventHandling: إحصائية ثانوية، لا نُظهر رسالة خطأ عامة إذا لم تتوفر
		*/
		fetchCountsByType ({ commit }) {
			return window.axios.get('/entitiesCountByType', { preventHandling: true }).then(({ data }) => {
				const customersCountsByType = (data || []).map(item => ({
					typeId: item.typeId !== undefined ? item.typeId : item.entityTypeId,
					count: item.count || 0
				}));
				commit(types.STORE_CUSTOMERS_COUNTS_BY_TYPE, customersCountsByType);
				return customersCountsByType;
			})
		},

		resetCountsByType ({ commit }) {
			commit(types.RESET_CUSTOMERS_COUNTS_BY_TYPE);
		},

		/*
			يعيد الجهة الممسوحة بالشكل { id, name, typeId, regionId } دائماً.
			رمز الـ QR لا يحمل بالضرورة كل الحقول، لذا نُكمل الناقص من الجهة المخزّنة
			محلياً إن وُجدت - وهذا ما يسمح بضبط فلاتر النوع/المنطقة في الشاشات
		*/
		fetchQr ({ getters }, { qrCodeData }) {
			const resolve = (decoded) => {
				const entity = normalizeQrEntity(decoded)
				if (!entity) return null

				const known = getters.getEntityById(entity.id)
				if (!known) return entity

				return {
					...known,
					...entity,
					name: entity.name || known.name || null,
					typeId: entity.typeId || known.typeId || null,
					regionId: entity.regionId || known.regionId || null
				}
			}

			const decodeLocally = () => decryptQrData(qrCodeData).then(resolve)

			if (!navigator.onLine) return decodeLocally()

			return window.axios.post('/entities/qrCode/decode', { qrCodeData }).then(({ data }) => resolve(data))
				.catch((error) => {
					if (error.response || error.code === 'ERR_CANCELED') throw error
					return decodeLocally()
				})
		},
		reset({ commit }) {
			commit(types.RESET_ENTITIES);
		},

		fetchAccount({ commit }) {
			return window.axios.get('/account/briefWithEntityTypeId').then(({ data }) => {
				commit(types.STORE_ACCOUNTS, data)
				return data 
			})
		}
	},

	mutations: {
		[types.STORE_ENTITIES](state, entities) {
			state.entities = entities;
		},

		[types.STORE_ALL_ENTITIES](state, entities) {
			state.allEntities = entities;
		},

		[types.RESET_ENTITIES](state) {
			state.entities = [];
			state.allEntities = [];
		},

		[types.STORE_CUSTOMERS_TYPES](state, customersTypes) {
			state.customersTypes = customersTypes
		},

		[types.STORE_CUSTOMERS_COUNTS_BY_TYPE](state, customersCountsByType) {
			state.customersCountsByType = customersCountsByType
		},

		[types.RESET_CUSTOMERS_COUNTS_BY_TYPE](state) {
			state.customersCountsByType = []
		},

		[types.STORE_ACCOUNTS](state, accounts) {
			state.accounts = accounts
		}
	},

	getters: {
		getEntityById: state => id => state.entities.find(c => sameId(c.id, id)) || state.allEntities.find(c => sameId(c.id, id)),
		getEntityByAccountId: state => accountId => state.entities.find(c => sameId(c.accountId, accountId) || sameId(c.id, accountId)) || state.allEntities.find(c => sameId(c.accountId, accountId) || sameId(c.id, accountId)),
		getCustomerTypeById: state => id => state.customersTypes.find(c => sameId(c.id, id))
	}
}